import api from 'utils/api';
import {Chat, ChatMessage, CurrentUser} from './types';
import {PaginatedResponse} from 'types/pagination';
import {ParamsType} from 'types/common';

const CHAT_URL = '/chat';

const getChatUsers = () => {
    return api.get<string[]>(`${CHAT_URL}/users`);
};

const getChats = () => api.get<Chat[]>(`${CHAT_URL}`, {}, {withoutGlobalLoader: true});

const getChatById = (chatId: string) => {
    return api.get<Chat>(`${CHAT_URL}/${chatId}`, {}, {withoutGlobalLoader: true});
};

const getPrivateChat = (userName: string) => {
    return api.get<Chat>(`${CHAT_URL}/private/${userName}`, {}, {withoutGlobalLoader: true});
};

const createGroupChat = (userIds: string[], title: string) => {
    return api.post<Chat>(`${CHAT_URL}/group`, {userIds, title}, {withoutGlobalLoader: true});
};
const editGroupChat = (chatId: string, title: string, userIds: string[]) => {
    return api.post<Chat>(
        `${CHAT_URL}/group/${chatId}`,
        {title, userIds},
        {withoutGlobalLoader: true},
    );
};

const getChatReadMessages = (chatId: string, params: ParamsType = {}) => {
    return api.get<PaginatedResponse<ChatMessage[]>>(
        `${CHAT_URL}/${chatId}/messages`,
        {...params},
        {withoutGlobalLoader: true},
    );
};

const getChatUnreadMessages = (chatId: string, params: ParamsType = {}) => {
    return api.get<PaginatedResponse<ChatMessage[]>>(
        `${CHAT_URL}/${chatId}/messages/unread`,
        {...params},
        {withoutGlobalLoader: true},
    );
};

const getCurrentUser = () => {
    return api.get<CurrentUser>('/me', {}, {withoutGlobalLoader: true});
};

export const ChatService = {
    getChats,
    getChatUsers,
    getChatReadMessages,
    getChatUnreadMessages,
    getCurrentUser,
    createGroupChat,
    getPrivateChat,
    getChatById,
    editGroupChat,
};
